import { gql } from "@apollo/client";

import { SEARCH_SUGGESTIONS_FRAGMENT } from "constants/suggestions";

export const SEARCH_NOTIFICATIONS = gql`
  query SearchNotifications($input: SearchInput!) {
    newNotificationsCount: notificationCount
    searchNotifications(input: $input) {
      edges {
        cursor
        node {
          id
          title
          body
          dismissed
          severity
          timestamp
          target
          type
          groupingKey
          occurrencesCount
          lastOccurrenceAt
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const SEARCH_NOTIFICATIONS_SUGGESTIONS = gql`
  query SearchNotificationsSuggestions($input: SearchSuggestionsInput!) {
    searchNotificationsSuggestions(input: $input) {
      ...SearchSuggestionsFragment
    }
  }
  ${SEARCH_SUGGESTIONS_FRAGMENT}
`;

export const DISMISS_NOTIFICATIONS = gql`
  mutation DismissNotifications($ids: [ID!]!) {
    dismissNotifications(ids: $ids) {
      id
      dismissed
    }
  }
`;
